<template>
  <div class="page">
    <!-- 特藏详情 start -->
    <div v-if="collData" class="resDetail">
      <h3 class="resTit">{{ collData.collectionName }}</h3>

      <!-- 资源列表 start -->
      <div class="resourceList">
        <div v-for="(item,index) in collData.resourcesVo" :key="index">
          <div v-if="item.resourceType == 'image'" class="img">

            <el-image :src="item.resourceCloudUrl" fit="contain" :lazy="true" @click="onOpen(item.resourceCloudUrl)" />
          </div>

          <div v-else-if="item.resourceType == 'video'" class="video">
            <video :id="item.resourceCloudUrl" :src="item.resourceCloudUrl" controls @play="handlePlay(item.resourceCloudUrl)" @error="handleEorror()" />
          <!-- autoplay -->
          <!-- <video :id='item.resourceCloudUrl' :loop='false' controls name="media" @play="handlePlay(item.resourceCloudUrl)">
            <source :src="item.resourceCloudUrl" type="video/mp4">
          </video> -->
          </div>

          <div v-else-if="item.resourceType == 'audio'" class="audio">
            <audio :id="item.resourceCloudUrl" controls @play="handlePlay(item.resourceCloudUrl)">
              <source :src="item.resourceCloudUrl">
              您的浏览器不支持 audio 元素。
            </audio>
          </div>

        </div>
      </div>
      <!-- 资源列表 end -->

      <!-- 资源信息 start -->
      <div class="resInfo">
        <dl v-if="collData.subtitle" class="itm">
          <dt>副标题</dt>
          <dd>{{ collData.subtitle }}</dd>
        </dl>
        <dl v-if="collData.chapter && collData.chapterOrder" class="itm">
          <dt>目次/序列</dt>
          <dd>{{ collData.chapter?collData.chapter:'-' }} , {{ collData.chapterOrder?collData.chapterOrder:'-' }}</dd>
        </dl>
        <dl v-if="collData.description" class="itm">
          <dt>馆藏描述</dt>
          <dd style="white-space: pre-wrap;">{{ collData.description }}</dd>
        </dl>
        <dl v-if="collData.keyword" class="itm">
          <dt>关键词</dt>
          <dd>{{ collData.keyword }}</dd>
        </dl>
        <dl class="itm">
          <dt>版权有者</dt>
          <dd>{{ collData.copyrightOwner }}</dd>
        </dl>

        <dl class="itm category">
          <dt>馆藏分类</dt>
          <dd>
            <span v-for="(cate,index) in collData.getCategory" :key="index"><em @click.stop="cateToSearch">{{ cate.cateName || '-' }} </em><em>/</em></span>
          </dd>
        </dl>

        <dl v-if="relatedTopic" class="itm">
          <dt>关联专题</dt>
          <dd @click.stop="topicToSearch"><span href="javascript:;">#{{ relatedTopic.topicName }}</span></dd>
        </dl>

        <dl v-if="collData.collectionsChapter.length" class="itm coll-itm">
          <dt>系列馆藏</dt>
          <!-- <dd v-if="!item.collectionName" /> -->
          <dd v-for="(item,index) in collData.collectionsChapter" :key="index" @click="relatedResource(item)"><span>{{ item.chapter?item.chapter + ',': '' }}{{ item.collectionName }}{{ item.subtitle?"-"+item.subtitle:'' }}</span></dd>
        </dl>
        <dl v-if="collData.collectionInfo" class="itm">
          <dt>馆藏信息</dt>
          <dd><em>{{ collData.collectionInfo }}</em></dd>
        </dl>
        <dl v-if="collData.commitByType == 1 && collData.user && collData.user.name" class="itm">
          <dt>发布人</dt>
          <dd @click="personSearch"><span style="text-decoration:none">{{ collData.user.name }}</span></dd>
        </dl>
        <dl v-if="collData.commitByType == 2 && collData.user && collData.user.name" class="itm">
          <dt>发布人</dt>
          <dd @click="personSearch"><span style="text-decoration:none">{{ collData.user.name }}</span></dd>
        </dl>
        <dl class="itm">
          <dt>发布日期</dt>
          <dd>{{ collData.publisherTime }}</dd>
        </dl>
      </div>
      <!-- 资源信息 end -->

      <!-- 底部操作按钮 start -->
      <div class="resOperate">
        <span class="btn" @click.stop="addCollect">
          <img v-if="collData.islikeCollection==1" src="../../../images/icon-colled.png">
          <img v-else-if="collData.islikeCollection==2" src="../../../images/icon-coll.png">收藏
        </span>
        <span class="btn" @click="toShare">
          <img src="../../../images/icon-share.png">分享
        </span>
        <span class="btn" @click.stop="reportColl">
          <img src="../../../images/icon-tipoff.png">举报
        </span>
      </div>
    <!-- 底部操作按钮 end -->

    </div>

    <div v-if="requestError" class="error-tip">
      <p>馆藏不可见或已下架</p>
    </div>
    <!-- 特藏详情 end -->

    <!-- 导航 start -->
    <div class="naviPosition" />
    <div class="digNavigate">
      <router-link class="navItm" :to="{ name: 'Waphome' }">
        <img src="../../../images/home.png" class="img-normal">
        <img src="../../../images/home_select.png" class="img-active">
        <label>首页</label>
      </router-link>
      <router-link class="navItm active" :to="{ name: 'Waplist' }">
        <img src="../../../images/res.png" class="img-normal">
        <img src="../../../images/res_select.png" class="img-active">
        <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapupload' }">
        <img src="../../../images/upload.jpg" class="img-normal">
        <img src="../../../images/upload_select.jpg" class="img-active">
        <label>上传</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapuser' }">
        <img src="../../../images/use.png" class="img-normal">
        <img src="../../../images/use_select.png" class="img-active">
        <label>我的</label>
      </router-link>
    </div>
    <!-- 导航 end -->
    <applyRemoveWap ref="delapply" :datas="reportList" @apply="requestReport" />
    <el-image-viewer v-if="showViewer" :initial-index="initialIndex" :on-close="()=>{showViewer=false}" style="background-color:#000" :url-list="imageList" />
  </div>

</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import api from '../../../api/collections.js'
import collectApi from '../../../api/userpage.js'
import user from '../../../models/user.js'
import search from '../../../models/search.js'
import auth from '../../../models/auth.js'
import applyRemoveWap from '@/components/applyremoveWap/index.vue'
import reportapi from '../../../api/common.js'
import { isWeiXin, isQQ, isDingTalk } from '../../../utils/utils.js'
 import homeapi from "../../../api/home.js";

export default {
  name: 'Wapdetail',
  components: {
    applyRemoveWap,
    ElImageViewer
  },
  data() {
    return {
      showViewer: false,
      initialIndex: 0,
      sourceMarkShowed: false,
      shareUrl: '',
      currentSource: null,
      currentIndex: 0,
      rsId: 0,
      collData: null,
      reportList: null,
      relatedTopic: null,

      isPlayUrl: '',
      imageList: [],
      requestError: false,
      isSkipAuth: false,
      permissions: null,
      iprange: false,
      clients:{},
      
    }
  },
  created() {
    this.requestclient();
    this.rsId = this.$route.query.rsId
    this.shareUrl = document.location.href
    this.isSkipAuth = this.$route.query.act || false
    this.permissions = parseInt(this.$route.query.permission)
    if (this.$route.query.me && this.$route.query.me === '1') {
      this.permissions = 1
    }
    this.checkIP()
  },

  methods: {
      //获取应用信息
      requestclient() {
        const that = this;
        homeapi
          .requestclient({ tenantId: this.$store.getters.tenantId })
          .then(r => {
            that.clients = r.data;
          })
          .catch(err => {
            console.log(err);
          });
      },
    onOpen(imageUrl) {
      this.initialIndex = this.imageList.findIndex(element => {
        return imageUrl === element
      })
      this.showViewer = true
    },
    checkIP() {
      const that = this
      api.ip({ tenantId: this.$store.getters.tenantId }).then(() => {
        that.iprange = true
        that.request()
      }).catch(() => {
        that.iprange = false
        that.request()
      })
    },
    request() {
      const that = this
      this.requestError = false

      if (this.permissions === 2 && this.iprange === false) {
        const userdata = user.getUserData()
        if (that.permissionRange === 2) {
          if (!userdata) {
            that.$router.push({
              name: 'Waplogin',
              query: {
                r: '/wap/detail?rsId=' + that.rsId
              }
            })
            return
          } else if (userdata.typeCode === 'P0') {
            if (that.isSkipAuth) {
              that.requestError = true
            } else {
              that.$router.push({
                name: 'Wapidentify',
                query: {
                  r: '/wap/detail?rsId=' + that.rsId,
                  skip: 'n'
                }
              })
            }
            return
          }
        }
      }

      api.detail({
        collectionId: this.rsId
      }).then(r => {
        if (that.iprange === false) {
          const userdata = user.getUserData()
          if (r.data.permissionRange === 4) {
            if (!userdata) {
              that.$router.push({
                name: 'Waplogin',
                query: {
                  r: '/wap/detail?rsId=' + that.rsId
                }
              })
              return
            } else if (userdata.id !== r.data.createUser) {
              that.requestError = true
              return
            }
          }
          if (that.permissions === 3) {
            that.requestError = true
            return
          }
        }

        that.collData = that.prepareData(r.data)
        console.log(that.collData)
        that.collData.resourcesVo.forEach(element => {
          if (element.resourceType === 'image') {
            that.imageList.push(element.resourceCloudUrl)
          }
        })
        if (r.data.resources && r.data.resources.length) {
          that.currentSource = r.data.resources[0]
          if (that.currentSource.resourceType === 'video') {
            // that.play()
          }
        }
      }).catch(error => {
        // 请求馆藏失败 给与提示
        that.requestError = true
        console.error(error)
      })
      reportapi.reportReason({
        code: 'delete_type'
      }).then(r => {
        console.log(r.data)
        that.reportList = r.data
      }).catch(error => {
        console.error(error)
      })
    },
    prepareData(v) {
      if (v.topicIdList.length) {
        console.log(v.topicIdList)
        const t = v.topicIdList[0]
        if (t.topicName && t.topicName !== '') {
          this.relatedTopic = t
        }
      }
      if (v.personAffected) {
        const ary = v.personAffected.split(',')
        v.personAffecteds = ary
      }
      return v
    },
    topicToSearch(v) { // 关联专题
      search.viewData = { params: { specialSubject: this.relatedTopic.id }, display: this.relatedTopic.topicName, type: 'specialSubject' }
      this.$router.push({
        name: 'Waplist'
      })
    },
    relatedResource(v) { // 系列馆藏
      if (isWeiXin()) {
        this.$router.push({ name: 'Wapdetail',
          query: {
            rsId: v.id,
            permission: v.permissionRange
          }})
      } else {
        const routeData = this.$router.resolve({
          name: 'Wapdetail',
          query: {
            rsId: v.id,
            permission: v.permissionRange
          }
        })
        window.open(routeData.href, '_blank')
      }
    },
    cateToSearch() { // 分类
      const v = this.collData.getCategory.pop()
      search.viewData = { params: { categoryId: v.id }, display: v.cateName, type: 'categoryId' }
      this.$router.push({
        name: 'Waplist'
      })
    },
    addCollect() { // 收藏
      if (!auth.gettoken()) {
        const that = this
        this.$router.push({
          path: '/wap/login/',
          query: {
            r: that.$router.history.current.fullPath
          }
        })
        return
      }
      if (this.collData.islikeCollection === 2) {
        const that = this
        collectApi.addColleciton({
          collectionCode: this.collData.collectionId
        }).then(r => {
          that.collData.islikeCollection = 1
          alert('收藏成功')
        }).catch(error => {
          if (error.code === 401) {
            that.$router.push({
              path: '/wap/login',
              query: {
                r: decodeURIComponent(that.$router.history.current.fullPath)
              }
            })
          } else {
            alert('举报失败')
          }
        })
      }
      if (this.collData.islikeCollection === 1) {
        const params = {
          collectionId: this.collData.collectionId,
          userId: user.getUserData().id
        }
        const that = this
        collectApi.removecollection(params).then(r => {
          that.collData.islikeCollection = 2
          alert('已取消收藏')
        }).catch(error => {
          if (error.codqe === 401) {
            that.$router.push({
              path: '/wap/login',
              query: {
                r: decodeURIComponent(that.$router.history.current.fullPath)
              }
            })
          } else {
            alert('举报失败')
          }
        })
      }
    },

    handlePlay(urls) { // 视频播放控制
      // const videoElement = this.videoElement
      if (this.isPlayUrl) {
        if (this.isPlayUrl !== urls) {
          const video1 = document.getElementById(this.isPlayUrl)

          video1.pause()
        }
      }
      // const video = document.getElementById(urls)

      this.isPlayUrl = urls

      // video.play()
    },
    requestReport(v) { // 请求举报
      console.log(this.rsId)
      console.log(v.id)
      const params = {
        collectionId: this.rsId,
        complaintTypeCode: v.id,
        complaintContent: v.id === 8 ? v.desc : null
      }
      const that = this
      api.report(params).then(r => {
        alert('举报成功')
      }).catch(error => {
        if (error.code === 401) {
          that.$router.push({
            path: '/wap/login',
            query: {
              r: decodeURIComponent(that.$router.history.current.fullPath)
            }
          })
        } else {
          alert('举报失败')
        }
      })
    },
    personSearch() {
      if (this.collData.commitByType === 1) {
        search.viewData = { params: { commitBy: this.collData.createUser }, display: this.collData.user.name, type: 'commitBy' }
      } else {
        search.viewData = { params: { commitBy: this.collData.createUser }, display: this.collData.user.name, type: 'commitBy' }
      }

      this.$router.push({
        name: 'Waplist'
      })
    },
    reportColl() { // 举报
      if (auth.gettoken()) {
        this.$refs.delapply.show()
      } else {
        const that = this
        this.$router.push({
          path: '/wap/login/',
          query: {
            r: decodeURIComponent(that.$router.history.current.fullPath)
          }
        })
      }
    },
    toShare() {
      if (isWeiXin() || isQQ() || isDingTalk()) {
        alert('请点击页面右上角进行分享')
      } else {
        alert('请使用浏览器分享功能进行分享')
      }
    }
  }
}
</script>

<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style scoped>
  .error-tip {
    position: absolute;
    top: 200px;
    width: 100%;
    text-align: center;
  }
  .error-tip p {
    font-size: 18px;
  }
</style>
